import React, { FormEvent } from 'react'
import queryString from 'query-string'
import { useHistory } from 'react-router-dom'

const EMAIL_FORM_ID: number = 464505
const FORM_SUBSCRIBE_URL: string = `https://api.convertkit.com/v3/forms/${EMAIL_FORM_ID}/subscribe`
const TAG_SUBSCRIBE_URL: string = `https://cj9thcorxi.execute-api.us-east-1.amazonaws.com/prod/submit_elementor_form`
// const TAG_SUBSCRIBE_URL = `https://api.might-could.com/prod/submit_elementor_form`;
const REDIRECT_URL: string = 'https://might-could.com/welcome-to-might-could/'

const redirect_to_success = (query: queryString.ParsedQuery<string>) => {
  const created_redirect_url = queryString.stringifyUrl({
    url: REDIRECT_URL,
    query: query,
  })
  window.location.replace(created_redirect_url)
}

const encode_dict = (data: object) => {
  let entries = Object.entries(data)
  let encoded_entries = entries.map(
    ([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`,
  )
  let encoded_query = encoded_entries.join('&')
  return encoded_query
}

type FormOptinProps = {
  buttonText: string
}

const SeeResultsOption: React.FC<FormOptinProps> = ({ buttonText }) => {
  const history = useHistory()

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    console.log('submit!')
    setTimeout(() => history.push('/style-results'), 1000)
  }
  // useScript('https://www.pineapplepodcasting.com/forms/2147700025/embed.js')

  return (
    <>
      <link
        rel='stylesheet'
        media='all'
        href='https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-ecdf08b1749d79682c2ab0463956d0c0ab955b29591a56ed173594b870d4dfb7.css'
      />
      <script src='https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-fd7a5360fe56f0a332f934492d89f18c2202d65871804504adca6fd4b6e78ceb.js'></script>
      <div id='kajabi-form' className='kajabi-form--inline'>
        <form
          onSubmit={handleSubmit}
          action='https://www.pineapplepodcasting.com/forms/2147746078/form_submissions'
          method='post'
          target='_blank'
          data-parsley-validate='true'
          data-kjb-disable-on-submit='true'
          acceptCharset='UTF-8'>
          <input name='utf8' type='hidden' value='&#x2713;' />
          <input
            type='hidden'
            name='authenticity_token'
            value='g2A4JMbL+KJAbTuiXjttfncPXqKL6BL7zYD0ES6uO7XSzcgE08shknPrA16XW2+4LdpRoV69EIHEfQ+98+RThA=='
          />
          <div className='kajabi-form__content'>
            <div className='kajabi-form__title'></div>

            <fieldset>
              <div className='text-field kajabi-form__form-item'>
                <input
                  type='text'
                  name='form_submission[name]'
                  id='form_submission_name'
                  required={true}
                  placeholder='First Name'
                />
              </div>
              <div className='email-field kajabi-form__form-item'>
                <input
                  required={true}
                  placeholder='Email Address'
                  data-parsley-remote='true'
                  data-parsley-remote-validator='kjb_email_validator'
                  type='email'
                  name='form_submission[email]'
                  id='form_submission_email'
                />
              </div>
              <button
                className='kajabi-form__btn kajabi-form__btn--block-mobile'
                type='submit'>
                See my podcasting style!
              </button>
            </fieldset>

            <br />
            <div className='kajabi-form__subtitle'>
              <p style={{ textAlign: 'center' }}>
                We hate spam and never send it.
              </p>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default SeeResultsOption

// const test = (

//   <link href='//fonts.googleapis.com/css?family=Open+Sans:400,700' rel='stylesheet' type='text/css'>
// 		<link rel="stylesheet" media="all" href="https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-ecdf08b1749d79682c2ab0463956d0c0ab955b29591a56ed173594b870d4dfb7.css" />
// 		<script src="https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-fd7a5360fe56f0a332f934492d89f18c2202d65871804504adca6fd4b6e78ceb.js">
// 			</script>
// 			<div id="kajabi-form" class="kajabi-form--inline">
// 				<form data-parsley-validate="true" data-kjb-disable-on-submit="true" action="https://www.pineapplepodcasting.com/forms/2147746078/form_submissions" accept-charset="UTF-8" method="post">
// 					<input name="utf8" type="hidden" value="&#x2713;" />
// 					<input type="hidden" name="authenticity_token" value="g2A4JMbL+KJAbTuiXjttfncPXqKL6BL7zYD0ES6uO7XSzcgE08shknPrA16XW2+4LdpRoV69EIHEfQ+98+RThA==" />
// 					<style id="form-embed-style" type="text/css">
// 					#kajabi-form .kajabi-form__btn {        color: #000000;        background-color: #d9559d !important;      }      #kajabi-form .kajabi-form__btn:not(.kajabi-form__btn--disabled):hover {
// 					  background-color: #a3256a;      }
// 						</style>
// 						<div class="kajabi-form__content">
// 							<div class="kajabi-form__title">
// 								</div>
// 								<div class="kajabi-form__subtitle">
// 									</div>
// 									<fieldset>
// 										<div class="text-field kajabi-form__form-item">
// 											<input type="text" name="form_submission[name]" id="form_submission_name" value="" required="required" placeholder="First Name" />
// 											</div>
// 											<div class="email-field kajabi-form__form-item">
// 												<input required="required" placeholder="Email Address" data-parsley-remote="true" data-parsley-remote-validator="kjb_email_validator" type="email" name="form_submission[email]" id="form_submission_email" /></div>      <button class="kajabi-form__btn kajabi-form__btn--block-mobile" type="submit">See My Podcasting Style!</button>
// 												</fieldset>
// 												</div>
// 												</form>
// 												</div>
// )
